import { Routes, Route, Navigate } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from './context/AuthContext';

import Home from './pages/Home';
import Login from './pages/Login';
import WorkOrder from './pages/WorkOrder';
import CreateWorkOrder from './pages/CreateWorkOrder';
import UserManagement from './pages/UserManagement';
import AssignWorkOrder from "./pages/AssignWorkOrder";
import SetInitialPassword from "./pages/SetInitialPassword";
import MyReports from "./pages/MyReports";

// Nelle routes:
<Route path="/assign-work-order" element={<AssignWorkOrder />} />
function App() {
  const { isLoggedIn } = useContext(AuthContext);

  return (
    <Routes>
      <Route
        path="/"
        element={
          isLoggedIn ? <Navigate to="/home" replace /> : <Login />
        }
      />
      <Route path="/home" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/set-password" element={<SetInitialPassword />} />
      <Route path="/work-orders" element={<WorkOrder />} />
      <Route path="/assign-work-order" element={<AssignWorkOrder />} />
      <Route path="/create-work-order" element={<CreateWorkOrder />} />
      <Route path="/user-management" element={<UserManagement />} />
      <Route path="/myreports" element={<MyReports />} />
      <Route path="/myreports/:codClient" element={<MyReports />} />
    </Routes>
  );
}

export default App;
